/**
 * @typedef {Object} ReadMoreProductComponent
 *
 * @description This component is used to scroll to and open the description disclosure when the button is clicked.
 * @example
 * <read-more-product-component>
 *     <button class="product-page__read-more" type="button">Read the full description</button>
 * </read-more-product-component>
 */
class ReadMoreProductComponent extends HTMLElement {
    button = null;
    Disclosure = null;
    DisclosureDetails = null;
    storeHeader = null;

    connectedCallback() {
        new DisclosureOpener(
            this.querySelector('button'),
            'details-disclosure#disclosure-summary-description'
        );
    }
}

if (!customElements.get('read-more-product-component')) {
    customElements.define('read-more-product-component', ReadMoreProductComponent);
}
